// src/firebase.js
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  signInAnonymously, 
  updateProfile,
  // NOUVEAUX IMPORTS
  GoogleAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut
} from "firebase/auth";
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCYr39KusPyStC713iQtlKG3mG7HzKvvzM",

  authDomain: "quizvs-fc72e.firebaseapp.com",

  databaseURL: "https://quizvs-fc72e-default-rtdb.europe-west1.firebasedatabase.app",

  projectId: "quizvs-fc72e",

  storageBucket: "quizvs-fc72e.firebasestorage.app",

  messagingSenderId: "594450747463",

  appId: "1:594450747463:web:ea1666a0ffc84467f6e162",

  measurementId: "G-LFY1SNQK9J"

};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Exporte tout ce dont nous avons besoin
export { 
  signInAnonymously, 
  updateProfile,
  // NOUVEAUX EXPORTS
  GoogleAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut 
};